import { cn } from '@cobliteam/ui/utils';
import type React from 'react';

export interface PageTabsProps {
  children: React.ReactNode;
  className?: string;
}

const PageTabs = ({ children, className }: PageTabsProps) => {
  return <div className={cn('flex flex-row', className)}>{children}</div>;
};

export default PageTabs;
